import num from 'numeral';

import {
  BasicReportRecord,
  BatchReportRecord,
  ProductSoldReportRecord,
  ReturnsReportRecord,
} from 'utils/apiClient/services/reports/types';
import { mapBatchReportsToMonthlyReports } from './utils';

export const getSoldProductsCount = (items: Array<ProductSoldReportRecord>) =>
  items.reduce((acc, item) => acc + item.sold_overall, 0);

export const getOrdersCount = (items: Array<BasicReportRecord>) =>
  items
    .reduce((acc, item) => acc.add(item.basket_count || 0), num(0))
    .value() ?? 0;

export const getReturnsCount = (items: Array<ReturnsReportRecord>) =>
  items.length;

export const getRevenueValue = (items: Array<BasicReportRecord>) =>
  items.reduce((acc, item) => acc.add(item.revenue || 0), num(0)).value() ?? 0;

export const getMarginValue = (items: Array<BasicReportRecord>) =>
  items.reduce((acc, item) => acc.add(item.profit || 0), num(0)).value() ?? 0;

export const getAvgBasketValue = (value: number, count: number) =>
  num(value)
    .divide(count || 1)
    .value() ?? 0;

export const getMonthlyReports = (data: BatchReportRecord[]) =>
  mapBatchReportsToMonthlyReports(data);
